import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table align-middle" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "p-3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-end p-3" }
const _hoisted_6 = { class: "pt-3 d-flex justify-content-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle ms-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pot_editor = _resolveComponent("pot-editor")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal, {
      idKey: _ctx.assetType,
      title: _ctx.assetName,
      ref: "potModal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_pot_editor, {
          ref: "potEditor",
          potFactory: _ctx.potFactory,
          currentValueLabel: _ctx.currentValueLabel,
          onCancelPotsEdit: _ctx.onPotCancelClicked,
          onSaveClicked: _ctx.onPotSaveClicked
        }, null, 8, ["potFactory", "currentValueLabel", "onCancelPotsEdit", "onSaveClicked"])
      ]),
      _: 1
    }, 8, ["idKey", "title"]),
    _withDirectives(_createElementVNode("table", _hoisted_1, [
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pots, (pot) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: pot.name
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("i", {
                class: "bi bi-trash text-primary",
                onClick: ($event: any) => (_ctx.onDeleteClicked(pot.id))
              }, null, 8, _hoisted_2)
            ]),
            _createElementVNode("td", _hoisted_3, [
              _createElementVNode("a", {
                href: "",
                class: "",
                onClick: ($event: any) => (_ctx.onEditPotClick($event, pot.name))
              }, _toDisplayString(pot.name), 9, _hoisted_4)
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.formatter.formatCurrency(pot.currentValue)), 1)
            ])
          ]))
        }), 128))
      ])
    ], 512), [
      [_vShow, _ctx.pots.length > 0]
    ]),
    _createElementVNode("p", _hoisted_6, [
      _createElementVNode("a", {
        href: "",
        class: "btn btn-outline-dark",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAddPotClick($event)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.addLabel) + " ", 1),
        _hoisted_7
      ])
    ])
  ], 64))
}